<template>
  <v-container class="login-container" fill-height fluid>
    <div class="login-background">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1903 556"
      >
        <path
          class="svg-banner-shape"
          d="M753.1,434.2c110.6,63.7,277.7,70.6,373.4,15.4L1905,0v555.9H0V0.2L753.1,434.2z"
        ></path>
      </svg>
    </div>
    <v-row align="center" justify="center" style="z-index: 10">
      <v-col cols="11" sm="7" md="5" lg="4" xl="3">
        <div class="logo text-center mb-12 font-weight-medium">
          <img :src="'/admin/assets/img/logos/homelogo.png'" />
        </div>
        <v-card>
          <template v-if="!sent">
            <v-card-title class="display-1 justify-center font-weight-medium">{{
              $t('forgotPassword.title')
            }}</v-card-title>
            <v-card-subtitle class="pt-2">{{
              $t('forgotPassword.subtitle')
            }}</v-card-subtitle>
            <v-card-text>
              <v-form @submit.prevent v-model="valid">
                <v-text-field
                  v-model="email"
                  :label="$t('email')"
                  name="email"
                  :rules="$rule('required|email')"
                  type="email"
                  outlined
                  dense
                  prepend-inner-icon="email"
                ></v-text-field>
                <div class="text-center mt-6">
                  <v-btn
                    class="d-block col-12"
                    color="primary"
                    depressed
                    large
                    @click="send"
                    :disabled="!valid"
                    :loading="loading"
                    >{{ $t('send') }}</v-btn
                  >
                  <div class="text-center mt-4">
                    <v-btn text color="grey" @click="back">{{
                      $t('return')
                    }}</v-btn>
                  </div>
                </div>
              </v-form @submit.prevent>
            </v-card-text>
          </template>
          <template v-else>
            <v-card-text>
              <!-- prettier-ignore -->
              <p class="mb-0 grey--text" style="white-space: pre-line">{{ $t('forgotPassword.emailSent') }}</p>
            </v-card-text>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { vueData } from '../../VueData';
  import AuthService from '../../api/services/auth.service';

  @Component
  export default class ForgotPassword extends Vue {
    authService = new AuthService();
    email: string = null;
    loading: boolean = false;
    sent: boolean = false;
    valid: boolean = false;

    async created() {}

    async send() {
      this.loading = true;

      try {
        await this.authService.forgot(this.email);
        this.sent = true;
      } catch (e) {
        console.error(e);
        vueData.serverError(e);
      } finally {
        this.loading = false;
      }
    }

    back() {
      this.$router.push('/login');
    }
  }
</script>
